import { useState, type ReactElement } from "react";
import { RootState } from "src/app/store";
import { useDispatch, useSelector } from "react-redux";
import { DashboardHome } from "src/features/dashboard";
import { useIdleTimer } from "react-idle-timer";
import { AppDispatch } from "src/app/store";
import LogoutModal from "src/features/authentication/components/LogoutModal";
import { logoutUser } from "src/features/authentication/hooks/userAuth";

export interface DashboardPageProps {

}

export function DashboardPage(props: DashboardPageProps): ReactElement {
        const { authUser } = useSelector((state: RootState) => state.auth);
        const [showLogoutModal, setShowLogoutModal] = useState(false);
        const dispatch = useDispatch<AppDispatch>();

        const onIdle = () => {
                if (showLogoutModal) {
                        dispatch(logoutUser(authUser));
                }
                setShowLogoutModal(false);
        }

        const staySignedIn = () => {
                setShowLogoutModal(false);
                reset();
        }

        const onPrompt = () => {
                setShowLogoutModal(true);
        }

        const { reset } = useIdleTimer({
                onIdle,
                onPrompt,
                timeout: 1000 * 60 * 8,
                promptBeforeIdle: 1000 * 60 * 3,
                debounce: 500
        })

        return <>
                <DashboardHome />
                {showLogoutModal ?
                        <LogoutModal title="Logout Modal" isOpen={showLogoutModal} onClose={staySignedIn} />
                        :
                        <></>
                }
        </>
}			
